import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M20.25 14.152v4.25c0 1.095-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.085-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.66V8.707c0-1.08-.768-2.015-1.837-2.175a48 48 0 0 0-3.413-.386m4.5 8.005c-.194.165-.42.296-.673.38A24 24 0 0 1 12 15.752a24 24 0 0 1-7.577-1.22 2 2 0 0 1-.673-.38m0 0a2.18 2.18 0 0 1-.75-1.66V8.707c0-1.08.768-2.015 1.837-2.175a48 48 0 0 1 3.413-.386m7.5 0v-.895a2.25 2.25 0 0 0-2.25-2.25h-3a2.25 2.25 0 0 0-2.25 2.25v.895m7.5 0a49 49 0 0 0-7.5 0M12 12.752h.008v.008H12z"
    }, null, -1)
  ])))
}
export default { render: render }